import React, { Component } from "react"
import { Query } from "react-apollo"
import { Helmet } from "react-helmet"
import { DEFAULT_LOGO } from "../../shared/constants"
import ApolloQueryHandler from "../../shared/apolloQueryHandler"
import GET_PAGE from "../../graphql/getPage.graphql"
import AuthHomePageContent from "../../components/AuthHomePageContent"
import HomePageContent from "../../components/HomePageContent"
import { MetaData, structuredPageData } from "../../shared/structureData"
import MarketingBar from "../../components/MarketingBar"
import { Redirect } from "react-router"

import "./home.scss"

class Home extends Component {
  renderSEO = () => {
    //RT: TODO down the road this should come from the DB.
    let seo = {}
    seo.type = "website"
    seo.url = "https://app.etr.ai/"
    seo.title = `Home | ETR`
    seo.image = DEFAULT_LOGO
    seo.description =
      "ETR is a primary technology market research firm, capturing real-time evaluations and spending intentions from thousands of enterprise-leading technologists."

    return (
      <Helmet>
        {MetaData(seo)}
        <script type="application/ld+json">
          {structuredPageData(seo.url)}
        </script>
      </Helmet>
    )
  }

  render() {
    return (
      <div>
        <div id="home-page-container">
          {!this.props.data.loading &&
          this.props.data.viewer.isUserAuthenticated ? (
            <div />
          ) : (
            <MarketingBar
              links={["/free-trial"]}
              bannerType={"single"}
              image="https://prod-etr.s3.amazonaws.com/uploads/images/banners/etr_banner_jan2021.png"
              trackEvent={this.props.trackEvent}
              location={"landing page not logged-in"}
            />
          )}
          {this.renderSEO()}
          {!this.props.data.loading &&
          this.props.data.viewer.isUserAuthenticated ? (
            <AuthHomePageContent
              {...this.props}
              components={this.props.data.page.components}
            />
          ) : (
            <HomePageContent {...this.props} />
          )}
        </div>
      </div>
    )
  }
}

const HomeWithData = (homePageProps) => {
  if (!homePageProps.viewer || !homePageProps.viewer.isUserAuthenticated) {
    return <Redirect to={{ pathname: "/login", state: { from: "/" } }} />
  }

  return (
    <Query query={GET_PAGE} variables={{ slug: "/" }}>
      {(queryProps) => {
        return (
          <ApolloQueryHandler {...queryProps} {...homePageProps}>
            {(props) => <Home {...props} />}
          </ApolloQueryHandler>
        )
      }}
    </Query>
  )
}

export default HomeWithData
